import React from "react";
import Grommet from "./Grommet";
import { RadioButton as GRadioButton } from "grommet";
const RadioButton = props =>
  props.custom ? (
    <Grommet
      theme={{
        radioButton: {
          size: "20px",
          border: {
            color: props.isWmoEnabled ? "dark-4" : "dark-3"
          },
          check: { extend: { border: `2px solid ${props.isWmoEnabled ? "#3E3E47" : "#2e4787"}` } },
          icon: { extend: { fill: props.isWmoEnabled ? "#3E3E47" : "#2e4787" } },
          extend: {
            alignSelf: "flex-start"
          }
        }
      }}
      style={props.isWmoEnabled ? {
        width: '100%', flexDirection: 'row',
        alignItems: 'center', borderRadius: '4px', background: props.checked ? '#F4F4F4' : 'white',
        border: props.checked ? '1.5px solid #3E3E47' : '1px solid #939398',
        padding: '12px 8px',
        marginBottom: props.index == props.addressLength -1 ? '0px' : '8px'
      } : {}}
    >
      <GRadioButton style={props.isWmoEnabled ? { width: '100%' } : {}} {...props}>{props.children}</GRadioButton>
    </Grommet>
  ) :
    (
      <GRadioButton {...props}>{props.children}</GRadioButton>
    );
export default RadioButton;
